import React, { FC } from 'react';
import { createPortal } from 'react-dom';
import { useContainer, Container } from '@surveycake/rhooks';

export interface PortalProps {
	/**
	 * HTMLElement, ref(createRef), component instance.
	 */
	container?: Container;
}

const Portal: FC<PortalProps> = ({ container, children }) => {
	const element = useContainer(container!);
	return element ?
		createPortal(children, element) :
		(<>{children}</>);
};

Portal.defaultProps = {
	container: document.body,
};

export default Portal;
